import type {ThemeCustomization} from "./tokens";

/**
 * Default theme customizations — the single place to brand-customize HeroUI themes.
 *
 * Override-only: only specify values that differ from HeroUI's built-in defaults.
 * Empty tokens object = use HeroUI defaults as-is for that theme.
 *
 * These are plain TypeScript objects — no CSS, no platform specifics.
 * - Web:    design-system-web reads these and injects a <style> tag with CSS variables.
 * - Native: design-system-native will read these and configure Uniwind/RN theme values.
 *
 * Example — brand-override the accent color:
 * @example
 * { themeId: 'light', tokens: { accent: 'oklch(0.55 0.20 260)', 'accent-foreground': 'oklch(0.98 0 0)' } }
 */
export const DEFAULT_THEME_CUSTOMIZATIONS: ThemeCustomization[] = [
  {
    themeId: "light",
    tokens: {
      // Override HeroUI light theme defaults here.
      // Example: accent: 'oklch(0.55 0.20 260)',
    },
  },
  {
    themeId: "dark",
    tokens: {
      // Override HeroUI dark theme defaults here.
      // Example: accent: 'oklch(0.75 0.18 260)',
    },
  },
];
